import Model from 'flarum/common/Model';
export default class Reaction extends Model {
  identifier() {
    return Model.attribute('identifier').call(this);
  }
  display() {
    return Model.attribute('display').call(this);
  }
  type() {
    return Model.attribute('type').call(this);
  }
  enabled() {
    return Model.attribute('enabled').call(this);
  }
  user_id() {
    return Model.attribute('user_id').call(this);
  }
  post_id() {
    return Model.attribute('post_id').call(this);
  }
  reaction_id() {
    return Model.attribute('reaction_id').call(this);
  }
}
flarum.reg.add('fof-reactions', 'common/models/Reaction', Reaction);